const API_BASE_URL_V1 = '/api/v1'

export default {
    PUBLIC_SHORT_URLS_V1: `${API_BASE_URL_V1}/public-short-urls`,
    USERS_V1: `${API_BASE_URL_V1}/users`,
}
